module.exports = __webpack_public_path__ + "static/img/Circles.dcfef993.svg";